import { PureComponent } from "react";
import ParagraphComponent from "/components/core/paragraph/paragraph-component";
import { componentStyles, animationStyles } from "./board-views-component.scss";
import LottieComponent from "/components/core/lottie/lottie-component";

const BOARD_VIEWS_ANIMATIONS = [
  {
    jsonPath: "/static/lottie/board-views/calendar.json",
    title: "boardView.calendar",
    href: "/features"
  },
  {
    jsonPath: "/static/lottie/board-views/graph.json",
    title: "boardView.chart",
    href: "/features"
  },
  {
    jsonPath: "/static/lottie/board-views/files.json",
    title: "boardView.files",
    href: "/features"
  },
  {
    jsonPath: "/static/lottie/board-views/kanban.json",
    title: "boardView.kanban",
    href: "/features"
  },
  {
    jsonPath: "/static/lottie/board-views/map.json",
    title: "boardView.map",
    href: "/features"
  },
  {
    jsonPath: "/static/lottie/board-views/timeline.json",
    title: "boardView.timeline",
    href: "/features"
  }
];

export default class BoardViewsComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      playAnimation: null
    };

    this.stopAnimation = this.stopAnimation.bind(this);
  }
  stopAnimation() {
    this.setState({ playAnimation: null });
  }

  playAnimation(animation) {
    this.setState({ playAnimation: animation });
  }

  renderAnimatedGallery() {
    const { translate } = this.props;
    return BOARD_VIEWS_ANIMATIONS.map((lottieAnimation) => {
      const shouldPlay = this.state.playAnimation === lottieAnimation.jsonPath;
      return (
        <div
          key={lottieAnimation.jsonPath}
          className="lottie-item-wrapper"
          onMouseEnter={this.playAnimation.bind(this, lottieAnimation.jsonPath)}
          onMouseLeave={this.stopAnimation}
        >
          <a href={lottieAnimation.href}>
            <LottieComponent
              jsonPath={lottieAnimation.jsonPath}
              autoplay={false}
              shouldPlay={shouldPlay}
              shouldPause={!shouldPlay}
              loop={true}
            />
            <div className="board-view-item-text">
              <div className="board-view-item-title">{translate(lottieAnimation.title)}</div>
            </div>
          </a>
          <style jsx>{animationStyles}</style>
        </div>
      );
    });
  }

  render() {
    return (
      <div className="board-views-component">
        <div className="paragraph-with-logos-wrapper">
          <ParagraphComponent {...this.props.paragraph} />
        </div>

        <div className="lottie-gallery-wrapper">{this.renderAnimatedGallery()}</div>

        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

BoardViewsComponent.defaultProps = {
  paragraph: {
    topic: { text: "Plan and track visually", color: "brand-red" },
    title: "Know where everything stands",
    body: [
      "Track all your team work and know where everything stand in a glance.",
      "Choose the best view for you that will boost your productivity."
    ],
    textDirection: "center"
  }
};
